






import { Component, Vue } from 'vue-property-decorator';
const imagesURL = require.context('@/assets/', true, /\.svg/);

@Component({
    props: {
        imgName: String,
        height: Number,
        width: Number,
    },
})
export default class ImageComponent extends Vue {
    public imagePath(name: string): string {
        return imagesURL(`./${name}.svg`);
    }
}
